/* eslint-disable max-nested-callbacks */
/* eslint-disable max-statements */
import React, { useCallback, useRef, useEffect } from 'react';
import { arrayOf, shape, bool, number, func } from 'prop-types';
import { Col, Row, Spin } from 'antd';
import { Transition, animated } from 'react-spring';
import { SpaceCard } from 'arcl';

function PaginatedSpaceCards({
  items,
  width,
  loading,
  hasMore,
  handleLoadMore,
  moreLoading,
  HandlePressEnter,
  updateContextAndNavigate,
}) {
  const AnimatedCol = animated(Col);
  const observer = useRef();

  const lastElementRef = useCallback(
    (node) => {
      if (loading || moreLoading || !hasMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          handleLoadMore();
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, moreLoading, hasMore, handleLoadMore],
  );

  useEffect(() => () => observer.current?.disconnect(), []);

  return (
    <>
      <Row gutter={[width > 768 ? 32 : 16, width > 768 ? 32 : 16]}>
        <Transition
          items={items.map((item, index) => ({ item, index }))}
          from={{ opacity: 0, y: 50 }}
          enter={{ opacity: 1, y: 0 }}
          leave={{ opacity: 0, y: 50 }}
          keys={(item) => item?.item?.id}>
          {(style, { item, index }) => (
            <AnimatedCol style={{ ...style }} xs={24} sm={24} md={12} lg={12} xl={8}>
              <div
                role="link"
                ref={items.length - 1 === index ? lastElementRef : null}
                tabIndex={0}
                className="space-card-wrapper arc-cursor-p"
                onClick={() => updateContextAndNavigate(item)}
                onKeyDown={(e) => HandlePressEnter(e, updateContextAndNavigate(item))}>
                <SpaceCard {...item} />
              </div>
            </AnimatedCol>
          )}
        </Transition>
      </Row>
      {moreLoading && (
        <div className="loader-container">
          <Spin size="large" />
        </div>
      )}
    </>
  );
}

PaginatedSpaceCards.propTypes = {
  items: arrayOf(shape()).isRequired,
  width: number.isRequired,
  loading: bool.isRequired,
  hasMore: bool.isRequired,
  handleLoadMore: func.isRequired,
  HandlePressEnter: func.isRequired,
  updateContextAndNavigate: func.isRequired,
  moreLoading: bool.isRequired,
};

export default PaginatedSpaceCards;
